import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { FaqDrill, FaqItem } from '@coin/shared/core/util-models';
import { FaqInbetweenLevelComponent } from '../faq-inbetween-level/faq-inbetween-level.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ChatBotComponent } from '@coin/chat-bot-feature';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-siemens-energy-faq-help-desk-level',
  templateUrl: './faq-help-desk-level.component.html',
  styleUrls: ['./faq-help-desk-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChatBotComponent, FaqInbetweenLevelComponent, V2ButtonComponent, TranslatePipe]
})
export class FaqHelpDeskLevelComponent {
  faqItem = input<FaqItem>();
  openFaq = output<FaqDrill>();

  public openHelpdesk(): void {
    window.open(environment.helpdeskUrl, '_blank');
  }
}
